import { render } from "./MMMSETrade.vue?vue&type=template&id=2b8e535e"
import script from "./MMMSETrade.vue?vue&type=script&lang=js"
export * from "./MMMSETrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__